import React from "react";
import {
  coachDemoImg,
  HeartIconRed,
  LocationIconGray,
} from "../../constant/imagePath";
import { AiFillHeart, AiFillStar } from "react-icons/ai";
import classes from "./FavouriteDetailCards.module.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import { BsDot } from "react-icons/bs";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Button } from "../Button/Button";
import { Col, Row } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import StarRatings from "react-star-ratings";

const FavouriteDetailCards = ({
  title,
  description,
  distance,
  rate,
  price,
  category,
  data,
}) => {
  return (
    <div className={`${classes.card} ${classes.marginBottom15}`}>
      <div>
        <img className={classes.favouriteDetailCardsImg} src={coachDemoImg} />
      </div>
      <div className={classes.mainContent}>
        <div className={classes.detailsContainer}>
          <div>
            <p style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
              {`${data?.firstName} ${data?.lastName}`}
            </p>

            <div className={`${classes.aCenter} ${classes.mt8}`}>
              <span className={classes.locIconSpan}>
                <ReactSVG
                  src={LocationIconGray}
                  beforeInjection={(svg) => svg.classList.add(classes.locIcon)}
                />
              </span>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                {data?.distance}
              </p>
              <span
                className={classes.dot}
                style={{ background: Colors.neutralShadesOfDimGray }}
              />
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                {data?.speciality}
              </p>
            </div>

            <p
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              className={`${classes.marginTop16} }`}
            >
              {data?.description.length > 130 ? (
                <>{data?.description?.slice(0, 130)}...</>
              ) : (
                <>{data?.description}</>
              )}
            </p>
          </div>
          <div className={classes.aCenter}>
            <p className={`${classes.starWithRating}`}>
              <StarRatings
                numberOfStars={1}
                starRatedColor={Colors.mainShadeOfRed}
                starEmptyColor={Colors.neutralShadesOfGainsboro}
                rating={data?.rating / 5}
                starDimension="16px"
              />
            </p>
            <p
              style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
              className={`${classes.dFlex}`}
            >
              {data?.rating?.toFixed(1)}
            </p>
            <span
              className={classes.dot}
              style={{ background: Colors.neutralShadesOfDimGray }}
            />
            <p
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
              className={classes.dFlex}
            >
              <span style={{ ...Fonts.b3 }}>${data?.price}/hr</span>
            </p>
          </div>
        </div>
        <div>
          <Button size={"Small"} icon={HeartIconRed} />
        </div>
      </div>
    </div>
  );
};

export default FavouriteDetailCards;
